import React from 'react'

interface SectionProperties {
  children: JSX.Element
  customClassName?: string
}

const Section = React.forwardRef<HTMLDivElement, SectionProperties>(
  ({ children, customClassName, ...otherProperties }, reference): JSX.Element => {
    return (
      <div ref={reference} className={`cmp-section ${customClassName ? customClassName : ''}`} {...otherProperties}>
        {children}
      </div>
    )
  },
)

export default Section
